// src/components/Header.js
import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { NavLink } from "react-router-dom";

const Header = () => {
  // Define the navigation items with their corresponding routes
  const navItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Payouts", path: "/payouts" },
    { label: "Shops", path: "/shops" },
    { label: "Affiliates", path: "/affiliates" },
    { label: "Logs", path: "/logs" },
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Left side text */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Admin
        </Typography>
        {/* Navigation buttons */}
        {navItems.map((item) => (
          <Button
            key={item.label}
            color="inherit"
            component={NavLink}
            to={item.path}
            sx={{
              textDecoration: "none",
              "&.active": {
                fontWeight: "bold",
              },
            }}
          >
            {item.label}
          </Button>
        ))}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
